export default {
  fetchDataSortKeys: [
    'ticker',
    'matchPrice',
    'totalMatchVolume',
    'rsi14',
    'ma20',
    'previousPrice',
    'previousVolume',
    'averagePrice2Week',
    'averageMatchVolume2Week',
    'icbRank',
    'averageMatchVolume1Month',
    'topPrevious',
    'rtd21',
    'rtd25',
    'ma5',
    'ma50',
    'ma100',
    'ma200',
    'returnDownTrend',
    'returnRecovery',
    'averageReturn',
  ],
  tabs: {
    accummulation: 1,
    breakOut: 2,
    breakOutMa: 3,
    bestInDowntrend: 4,
    marketAnomaly: 5,
  },

  //filter tap 1
  filterTabOne: {
    filterAccumulationPeriod: {
      1: 5,
      2: 10,
      3: 20,
      4: 40,
    },

    filterVolumeRateChange: {
      1: 2,
      2: 3,
      3: 4,
      4: 5,
    },
    filterIncreasePrice: {
      1: 0.01,
      2: 0.03,
      3: 0.05,
      4: 0.07,
    },
  },

  filterBreakout: {
    breakOutType: {
      TOP: 'Top',
      BOTTOM: 'Bottom',
    },
    filterTimeRange: {
      1: 'ThreeMonths',
      2: 'SixMonths',
      3: 'NineMonths',
      4: 'OneYear',
    },

    filterVolumeRateChange: {
      1: 1,
      2: 2,
      3: 4,
      4: 6,
    },

    filterCompGroup: {
      1: 'All',
      2: 'VN30',
      3: 'VNMiD',
      4: 'VNSmall',
    },
  },

  filterBreakoutMa: {
    breakOutType: {
      CROSS_UP: 'CrossUp',
      CROSS_DOWN: 'CrossDown',
    },

    breakoutMaBottom: {
      1: 'MA20',
      2: 'MA50',
      3: 'MA100',
      4: 'MA200',
    },

    filterVolumeRateChange: {
      1: 1,
      2: 2,
      3: 4,
      4: 6,
    },

    filterIncreasePrice: {
      1: 0.01,
      2: 0.03,
      3: 0.05,
      4: 0.07,
    },
  },

  filterBestDownTrend: {
    downTrend: {
      1: 'Recent6M',
      2: 'Recent1Y',
      3: 'Recent2Y',
      4: 'Recent3Y',
    },

    avgVolume: {
      1: 50000,
      2: 100000,
      3: 300000,
      4: 500000,
    },

    filterCompGroup: {
      1: 'All',
      2: 'VN30',
      3: 'VNMiD',
      4: 'VNSmall',
    },
  },

  filterMarketAbnormally: {
    optionTime: {
      Daily: 'Daily',
      Monthly: 'Monthly',
      Quarterly: 'Quarterly',
    },
    filterWeekday: {
      1: 'mon',
      2: 'tue',
      3: 'wed',
      4: 'thu',
      5: 'fri',
    },
    filterMonthly: {
      1: 'jan',
      2: 'feb',
      3: 'mar',
      4: 'apr',
      5: 'may',
      6: 'jun',
      7: 'jul',
      8: 'aug',
      9: 'sep',
      10: 'oct',
      11: 'nov',
      12: 'dec',
    },
    filterQuarterly: {
      1: 'i',
      2: 'ii',
      3: 'iii',
      4: 'iv',
    },
    filterTimeRange: {
      1: 'ThreeYears',
      2: 'FiveYears',
      3: 'TenYears',
      4: 'AllTime',
    },

    avgVolume: {
      1: 50000,
      2: 100000,
      3: 300000,
      4: 500000,
    },

    filterCompGroup: {
      1: 'All',
      2: 'VN30',
      3: 'VNMiD',
      4: 'VNSmall',
    },
  },

  tableAccumulation: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    VOL: 'totalMatchVolume',
    RSI14: 'rsi14',
    MA20: 'ma20',
    PRICE_PREV: 'previousPrice',
    VOL_PREVIOUS: 'previousVolume',
    PRICE_AVG: 'averagePrice2Week',
    VOL_AVG: 'averageMatchVolume2Week',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  tableBreakOut: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    VOL: 'totalMatchVolume',
    AVG_VOL_1M: 'averageMatchVolume1Month',
    RSI14: 'rsi14',
    MA20: 'ma20',
    TOP_PREVIOUS: 'topPrevious',
    PE: 'rtd21',
    PB: 'rtd25',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    HIGHEST: 'highestPrice',
    LOWEST: 'lowestPrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  tableBreakOutBottom: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    VOL: 'totalMatchVolume',
    AVG_VOL_1M: 'averageMatchVolume1Month',
    RSI14: 'rsi14',
    MA20: 'ma20',
    BOTTOM_PREVIOUS: 'bottomPrevious',
    PE: 'rtd21',
    PB: 'rtd25',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    HIGHEST: 'highestPrice',
    LOWEST: 'lowestPrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  tableBreakOutMa: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    MA5: 'ma5',
    MA20: 'ma20',
    MA50: 'ma50',
    MA100: 'ma100',
    MA200: 'ma200',
    VOL: 'totalMatchVolume',
    RSI14: 'rsi14',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  tableBestInDowntrend: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    VOL: 'totalMatchVolume',
    AVG_VOL_1M: 'averageMatchVolume1Month',
    RETURN_DOWNTREND: 'returnDownTrend',
    RETURN_RECOVERY: 'returnRecovery',
    PE: 'rtd21',
    PB: 'rtd25',
    MA20: 'ma20',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  tableMarketAnomaly: {
    TICKER: 'ticker',
    PRICE: 'matchPrice',
    VOL: 'totalMatchVolume',
    AVG_RETURN: 'averageReturn',
    RSI14: 'rsi14',
    MA20: 'ma20',
    PE: 'rtd21',
    PB: 'rtd25',
    RANKING: 'icbRank',
    CEILING_PRICE: 'ceilingPrice',
    FLOOR_PRICE: 'floorPrice',
    REF_PRICE: 'referencePrice',
    TOTAL_RANK: 'icbTotalRanked',
  },

  listHideColumn: [
    'ceilingPrice',
    'floorPrice',
    'referencePrice',
    'priceChange',
    'highestPrice',
    'lowestPrice',
    'icbTotalRanked',
  ],
  accumulationInterval: 1000 * 31,
  breakoutInterval: 1000 * 31,
  breakoutMaInterval: 1000 * 31,
  bestDownInterval: 1000 * 31,
  marketAbnormallyInterval: 1000 * 31,
};
